import Vue from "vue";
import {DateTime, Duration} from "luxon";
import {addDateFilters} from "../../administration/filtres/dates";

addDateFilters(Vue);

/**
 * Filtres
 */
Vue.filter('minutesToTime', function (minutes) {
    var duration = Duration.fromObject({ minutes: minutes });
    return duration.toFormat('h\'h\'mm\'min\'');
})

Vue.filter('formatPrice', function (value) {
    if (!value) return ''
    return parseFloat(value / 100).toFixed(2) + ' €';
})

Vue.filter('formatPriceWithoutSpace', function (value) {
    if (!value) return ''
    return parseFloat(value / 100).toFixed(2) + '€';
})

Vue.filter('dateInFrench', function (value) {
    if (!value) return ''
    const dates = {
        monday: "Lundi",
        tuesday: "Mardi",
        wednesday: "Mercredi",
        thursday: "Jeudi",
        friday: "Vendredi",
        saturday: "Samedi",
        sunday: "Dimanche",
    }
    return dates[value];
});

Vue.filter('formatHoraire', function (value) {
    if (!value) return ''
    if(value === "24hrs") return "24h"
    return DateTime.fromFormat(value, 'HHmm').toFormat("HH'h'mm");
})
